import * as React from 'react'

export function ArchetypesFloorLantern(props) {
  return (
    <svg viewBox='0 0 32 33' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M18.523 13.383c-1.433-.503-3.614-.503-5.046 0l-1.212-8.617c2.372.301 5.098.301 7.47.001l-1.212 8.616zM22.44.756C18.9-.252 13.09-.252 9.553.756c-3.487.994-3.374 2.576.165 3.535.15.04.32.069.475.106l1.572 11.175c.118.437.777.958 2.235 1.239v12.34c-.975.159-1.69.429-1.92.75a.368.368 0 00-.08.224v.75C12 31.496 13.791 32 16 32c2.21 0 4-.504 4-1.125v-.75c0-.415-.81-.773-2-.969V16.812c1.452-.282 2.083-.804 2.234-1.238l1.572-11.176c.157-.037.331-.067.482-.107 3.536-.959 3.643-2.541.152-3.535z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
